import styled from "styled-components";

export const Content = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
    gap: 10px;

    h2 {
      text-align: center;
      margin-bottom: 20px;
    }

    .section {
      margin-bottom: 20px;
    }

    .section h3 {
      color: #333;
      margin-bottom: 10px;
    }

    .section p {
      margin-bottom: 8px;
    }

    ol {
      list-style-position: inside;
    }

    ol li {
      margin-bottom: 5px;
    }
`;